
function getGisCoords(parid) {
	return $.ajax({
		url: paoDetails.context.child_uri + "/models/pao-model-gis.php?parid=" + parid,
		method: "GET",
		dataType: "json"
	});
}

function getParcelCoords(parid) {
	return new Promise(function (resolve, reject) {
		if (paoDetails.context.datums.parid !== parid) {
			getGisCoords(parid)
				.then(function (data) {
					var coords = {
						lat: '',
						lon: ''
					};
					paoDetails.context.datums.parid = parid;

					var numCols = data.cols.length;
					var numRows = data.rows.length;
					var xcoord, ycoord, sqft, hasAddress;

					for (var r = 0; r < numRows; r++) {
						if (numCols > 0) {
							xcoord = data.rows[r][1]; 
							ycoord = data.rows[r][2]; 
							hasAddress = data.rows[r][4];
							sqft = data.rows[r][7]; 	
							paoDetails.context.sqft = sqft;
						}
					}
					if (hasAddress && hasAddress === "0") {
						getParcelCentroid(parid)
							.then(function (response) {
								if (response.hasOwnProperty('features')) {
									if (response.features.length > 0) {
										if (response.features[0].hasOwnProperty('attributes')) {
											if (response.features[0].attributes.hasOwnProperty('LAT'))
												coords.lat = response.features[0].attributes.LAT;
											if (response.features[0].attributes.hasOwnProperty('LON'))
												coords.lon = response.features[0].attributes.LON;

											paoDetails.context.datums.coordinates = coords;
										}
									} else {
										paoDetails.context.datums.usesDefaults = true;
									}
								}
							})
							.catch(function (error) {
								console.error(error);
								reject(false);
							})
							.finally(function () {
								resolve(true);
							});
					} else {
						if (xcoord && ycoord) {
							coords.lat = ycoord;
							coords.lon = xcoord;
							paoDetails.context.datums.coordinates = coords;
							resolve(true);
						} else {
							resolve(true);
						}
					}
				});
		} else {
			resolve(true);
		}
	});
}

function getParcelCentroid(parid) {
	return new Promise((resolve, reject) => {
		require([
			'esri/rest/support/Query',
			'esri/rest/query'
		], function (Query, query) {

			let queryObject = new Query({
				returnGeometry: false,
				returnTrueCurves: false,
				returnIdsOnly: false,
				returnCountOnly: false,
				returnZ: false,
				returnM: false,
				returnDistinctValues: false,
				returnExtentOnly: false,
				outFields: ["LAT", "LON"],
				where: "PARID='" + parid + "'",
				orderByFields: ['PARID']
			});
			let url = paoDetails.gis.services.pictoWebSearch.url;
			query
				.executeQueryJSON(url, queryObject)
				.then((response) => {
					resolve(response);
				})
				.catch((error) => {
					console.error(error);
					reject(false);
				});
		});
	});
}


async function showGoogleStreetViewImage() {
	try {
		let lat = '', lon = '', sqft = '0';

		if (paoDetails.modules.streetview.loaded) {
			await showTab('streetMap');

		} else {

			$("#streetMapViewer").remove();
			$("#streetMap .not-available").remove();
			$("#streetMap .not-available-image").remove();


			await showTab('streetMap');

			if (paoDetails.context.datums.usesDefaults) {
			} else {
				lat = paoDetails.context.datums.coordinates.lat;
				lon = paoDetails.context.datums.coordinates.lon;
				sqft = paoDetails.context.sqft;
			}
			lat = Number.parseFloat(lat).toFixed(6);
			lon = Number.parseFloat(lon).toFixed(6);

			let parid = paoDetails.context.parid;
			let mob = paoDetails.support.isMobileDevice;
			let obj = {
				"parid": parid,
				"mobile": mob,
				"location": lat + "%2C" + lon,
				"sqft": sqft,
				"format": "png32",
				"content-type": "png",
				"map-type": "street-view",
				"visitor-ip": paoDetails.client.visitorIP
			};
			let data = JSON.stringify(obj);
			getGoogleStreetViewImage(data)
				.then(function (result) {
					removeBusy('streetMap');
					paoDetails.modules.streetview.loaded = true;
					if (result) {
						return addStreetviewImage(result);
					} else {
						return addNoStreetviewImage();
					}
				})
				.catch(function (error) {
					console.error(error);
				});
		}
	} catch (error) {
		console.error(error);
	}
}

function showGoogleMapsUrlBySearch(queryMethod = 'address') {


	if (queryMethod === 'coords') {


		let lat = '', lon = '';

		if (paoDetails.context.datums.usesDefaults) {
		} else {
			lat = paoDetails.context.datums.coordinates.lat;
			lon = paoDetails.context.datums.coordinates.lon;
		}
		lat = Number.parseFloat(lat).toFixed(6);
		lon = Number.parseFloat(lon).toFixed(6);

		return `https://www.google.com/maps/search/?api=1&query=${lat}%2C${lon}`;

	} else if (queryMethod === 'address') {

		return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;

	} else {
	}
}

function addStreetviewImage(img64) {
	let tf = false;
	let sm = document.getElementById('streetMap');
	if (sm) {
		let dv = document.createElement('div');
		dv.setAttribute("id", "streetMapViewer");
		let img = document.createElement('img');
		img.className = "streetview-image";
		img.src = img64;
		dv.appendChild(img);
		sm.appendChild(dv);
		tf = true;
	}
	return tf;
}

function addNoStreetviewImage() {
	if ($('#streetMap .not-available')?.length)
		return;

	let tf = false;
	let sm = document.getElementById('streetMap');
	if (sm) {
		let fragment = document.createDocumentFragment();
		let div = document.createElement('div');
		div.setAttribute("class", "not-available-image");
		let img = document.createElement('img');
		img.src = "/wp-content/themes/frontier-child/images/mcpao-logo.svg";
		div.appendChild(img);
		fragment.appendChild(div);
		div = document.createElement('div');
		div.setAttribute("class", "not-available");
		let p = document.createElement("p");
		p.innerHTML = "Sorry, a Google Street View is not available for this parcel.";
		div.appendChild(p);
		fragment.appendChild(div);
		sm.appendChild(fragment);
		tf = true;
	}
	return tf;
}

function obliqueNotAvailable() {

	var tf = false;
	var el = document.getElementById('pictometry_ipa_container');
	if (el) {

		$("#pictometry_ipa_container .dv-no-oblique").remove();

		var fragment = document.createDocumentFragment();
		var dv = document.createElement('div');
		dv.setAttribute("class", "dv-no-oblique");

		var img = document.createElement('img');
		img.setAttribute("class", "no-oblique");
		img.src = '/wp-content/themes/frontier-child/images/NoObliqueImagery.gif';
		dv.appendChild(img);

		fragment.appendChild(dv);
		el.appendChild(fragment);

		showTab('obliqueImagery');

		tf = true;
	}
	return tf;
}

function getGoogleStreetViewImage(data) {
	return new Promise(function (resolve, reject) {
		let parid = paoDetails.context.parid;
		let storageId = `${parid}_streetviewstatic`;
		if (sessionStorage && sessionStorage.getItem(storageId)) {
			let storedJson = JSON.parse(sessionStorage.getItem(storageId));
			if (storedJson) {
				resolve(storedJson.imgSrc);
				return;
			}
		} else {
			let n = Object.keys(sessionStorage).filter(x => x.endsWith('_streetviewstatic'));
			if (n?.length > 0) {
				n.forEach(e => {
					sessionStorage.removeItem(e);
				});
			}
		}
		$.ajax({
			url: paoDetails.context.child_uri + "/controllers/pao-googleapis.php",
			type: "POST",
			data: { 'params': data },
			dataType: "text"
		})
			.fail(function (jqXHR, textStatus, errorThrown) {
				var err = textStatus + ", " + errorThrown;
				console.error("Google Street View Image Request Failed: " + err);
				reject(err);
			})
			.done(function (data) {
				if (data?.length) {
					if (sessionStorage && !sessionStorage.getItem(storageId)) {
						let json = { imgSrc: data }
						sessionStorage.setItem(storageId, JSON.stringify(json));
					}
				}
				resolve(data);
			});
	});
}

function getGoogleAerialView() {
	return new Promise(function (resolve, reject) {
		let parid = paoDetails.context.parid;
		let storageId = `${parid}_aerialview`;
		if (sessionStorage && sessionStorage.getItem(storageId)) {
			let storedJson = JSON.parse(sessionStorage.getItem(storageId));
			if (storedJson) {
				let ts = Math.floor(new Date().getTime() / 1000);
				let expires_ts = parseInt(storedJson.expires_ts);
				if (expires_ts > ts) {
					let rtn = JSON.stringify(storedJson);
					resolve(rtn);
					return;
				} else {
					sessionStorage.removeItem(storageId);
				}
			}
		}
		let mob = paoDetails.support.isMobileDevice;
		let obj = { "parid": parid, "map-type": "aerial-view", "mobile": mob, "visitor-ip": paoDetails.client.visitorIP };
		let data = JSON.stringify(obj);

		$.ajax({
			url: paoDetails.context.child_uri + "/controllers/pao-googleapis.php",
			type: "POST",
			data: { 'params': data },
			dataType: "text"
		})
			.fail(function (jqXHR, textStatus, errorThrown) {
				let err = textStatus + ", " + errorThrown;
				console.error("Google Aerial View Request Failed: " + err);
				reject(err);
			})
			.done(function (result) {
				let rtn = "";
				if (result && result?.length)
					rtn = result;
				resolve(rtn);
			});
	});
}